
export function getAvatarUrl(id: string) {
    return import.meta.env.VITE_APP_AVATAR_URL + '/v' + import.meta.env.VITE_APP_API_VERSION + `/avatar/user/${id}/`
}